import React from 'react';
import { number } from '../../../Common/Util/number';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';
import TableComponent from '../../../Common/Charts/TableCharts';

export const TableHouseHoldAndIndividualRegister = () => {
    const { chartData } = useResultsChartsDataContext();

    const columns = [
        {
            key: 'monthYear',
            header: 'Mês/Ano',
            headerStyle: {
                width: '25%',
                fontWeight: '500' 
            },
            cellStyle: {
            }
        },
        {
            key: 'domiciliar',
            header: 'Domiciliar',
            headerStyle: {
                width: '25%',
                textAlign: 'right',
                fontWeight: '500' 
            },
            cellStyle: {
                textAlign: 'right'
            },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'individual',
            header: 'Individual',
            headerStyle: {
                width: '25%',
                textAlign: 'right',
                fontWeight: '500' 
            },
            cellStyle: {
                textAlign: 'right'
            },
            formatter: (value) => number.formatToBRNumber(value)
        },
        {
            key: 'relation',
            header: 'Relação',
            headerStyle: {
                width: '25%',
                textAlign: 'right',
                fontWeight: '500' 
            },
            cellStyle: {
                textAlign: 'right'
               
            },
            formatter: (value) => number.formatToBRNumber(value)
        }
    ];

    const calculateTotals = (data) => {
        if (!data || !Array.isArray(data)) return null;

        const domiciliarTotal = data.reduce(
            (acc, curr) => acc + Number(curr.domiciliar || 0),
            0
        );
        const individualTotal = data.reduce(
            (acc, curr) => acc + Number(curr.individual || 0),
            0
        );
        const relationTotal =
            domiciliarTotal > 0
                ? (individualTotal / domiciliarTotal).toFixed(2)
                : 0;

        return {
            monthYear: 'Total',
            domiciliar: domiciliarTotal,
            individual: individualTotal,
            relation: relationTotal
        };
    };

    const tableData = React.useMemo(() => {
        if (!chartData?.tableHouseHoldAndIndividualRegister) return [];

        const data = [...chartData.tableHouseHoldAndIndividualRegister];
        const totals = calculateTotals(
            chartData.tableHouseHoldAndIndividualRegister
        );

        if (totals) {
            data.push(totals);
        }

        return data;
    }, [chartData?.tableHouseHoldAndIndividualRegister]);

    return (
        <div className="chart-container-dashboards">
            <TableComponent
                className="w-100"
                data={tableData}
                columns={columns}
                title="Totais"
                showTotal={false}
                maxHeight="400px"
                isLastTotal={true}
            />
        </div>
    );
};
